export default __webpack_public_path__ + "static/media/P1.0187b7af.svg";